var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slideDown"}},[(_vm.videoName)?_c('div',{staticClass:"overlayTutorial"},[_c('video',{attrs:{"autoplay":""},on:{"click":_vm.togglePlay}},[_c('source',{attrs:{"src":_vm.returnVideoPath('assets/video/'),"type":"video/mp4"}})]),_vm._v(" "),_c('div',{staticClass:"overlayTutorial__play"})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b5c349e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OverlayTutorial.vue
// module id = 83
// module chunks = 0